import Vue from 'vue';
import App from "./views/app.vue"


//orgchart插件的 id:svg_wrapper.重复冲突

(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }
    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            console.log('-----init', props)

            const key = props.data ? props.data.flag : ""

            switch (key) {
                //查看
                case "initialize":
                    console.log('-----查看', props.data.data)
                    setHtml(this.model, props, function (self) {
                        self.$refs.mainview.editStatus = false
                        self.$refs.mainview.initDim(props.data.data || [])
                    })
                    break;
                // 新增
                case "crtstydimension":
                    console.log('-----新增', props.data.data)
                    setHtml(this.model, props, function (self) {
                        self.$refs.mainview.editStatus = true
                        self.$refs.mainview.resetDim(props.data.data || [])
                    })
                    break;
                // 复制
                case "copy":
                    console.log('-----复制', props.data.data)
                    setHtml(this.model, props, function (self) {
                        self.$refs.mainview.editStatus = true
                        self.$refs.mainview.initDim(props.data.data || [])
                    })
                    break;
                default:
                    setHtml(this.model, props)
                    break;
            }
        },
        update: function (props) {
            if (props.data && props.data.initevents) return

            console.log('-----update', props)

            const eventName = props.data ? props.data.flag : ""

            if (!eventName) return

            switch (eventName) {
                //编辑
                case "modify":
                    this.model.myvue.$refs.mainview.editStatus = true
                    break;
                case "crtstydimension":
                    this.model.myvue.$refs.mainview.editStatus = true
                    this.model.myvue.$refs.mainview.resetDim(props.data.data || [])
                    break;
                case "cardstyle":
                    this.model.myvue.$refs.mainview.editStatus = true
                    this.model.myvue.$refs.mainview.setCardStyles(props.data.data || {})
                    break;
            }
        },
        destoryed: function () {
            console.log('-----destoryed', this.model)
        }
    }

    const setHtml = (model, props, cb) => {
        const { invoke, dom } = model
        KDApi.loadFile('./css/index.css', model, () => {
            model.myvue = new Vue({
                el: model.dom,
                template: '<App ref="mainview" />',
                components: {
                    App
                },
                data: {
                    model,
                    KDApi
                },
                provide: function () {
                    return {
                        model,
                        KDApi,
                        myInvoke: this.invoke
                    }
                },
                destoryed() {
                    console.log('Vue destory')
                },
                mounted() {
                    cb && cb(this)
                    // this.$refs.mainview.initData(props.data.data || [])
                },
                methods: {
                    invoke: function (eventName, args) {
                        invoke(eventName, args)
                    }
                }
            })

        })
    }

    // 注册自定义组件
    KDApi.register('kdchartPreviews', MyComponent, {
        isMulLang: true
    })
})(window.KDApi)